import React from "react";
import cancelIcon from "assets/images/watchNow/cancel.svg";

import "./watchNow.scss";
import useScreenMobile from "hooks/useScreenMobile";

const WatchNow = ({ setShowWatchNow }) => {
  const isMobile = useScreenMobile({ size: 678 });
  return (
    <div className="watchNowContainer">
      <div className="watchNowContent">
        <p className="watchNowDetail">
          Watch our pitch on Shark Tank and see how we took on the challenge!{" "}
          {isMobile ? (
            <a
              href="https://www.youtube.com/watch?v=fXxzpkM5Zzo"
              target="_blank"
              rel="noreferrer"
              className="watchNow"
            >
              Watch Now
            </a>
          ) : (
            ""
          )}
        </p>
        {!isMobile && (
          <a
            href="https://www.youtube.com/watch?v=fXxzpkM5Zzo"
            target="_blank"
            rel="noreferrer"
            className="watchNow"
          >
            Watch Now
          </a>
        )}
      </div>
      <img
        src={cancelIcon}
        alt="cancelIcon"
        onClick={() => {
          setShowWatchNow(false);
        }}
      />
    </div>
  );
};

export default WatchNow;
